import { useContext } from "react"
import { usePhotos } from "web/hooks/data"
import { NavigationContext } from "web/contexts"
import GalleryTile from "./Gallery"

export default function ViewableGalleryTile({
  canEdit,
  isDropzoneDisabled,
  isTemplate,
  tileFetchParams,
  overview,
}) {
  const { viewGroup } = useContext(NavigationContext)

  const photos = usePhotos({
    subjectType: viewGroup.parent_subject_type.toLowerCase(),
    subjectId: viewGroup.parent_subject_id,
  })

  return GalleryTile({
    canEdit,
    photos,
    isDropzoneDisabled,
    isTemplate,
    tileFetchParams,
    overview,
  })
}
